import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { buscar } from '../actions'
import { Spinner } from 'scorpion-core';

import View from 'react-flexbox'
export const withPerfilUser = ComponentW => {
    class WithPerfilUser extends Component {

        componentDidMount() {
            this.props.buscarPerfil();
        }

        render() {
            const { error, loading, perfilUser } = this.props


            return <View>
                {error && <Typography>{error}</Typography>}
                {loading ? <Spinner /> : <ComponentW perfilUser={perfilUser} {...this.props} />}

            </View>
        }
    }
    const mapStateToProps = ({ PerfilUserReducer }) => {
        return { error: PerfilUserReducer.rPerfil.error, loading: PerfilUserReducer.rPerfil.loading, perfilUser: PerfilUserReducer.rPerfil.obj, };
    };


    return compose(
        connect(mapStateToProps, {  buscarPerfil :buscar }),
    )(WithPerfilUser)
}








// WEBPACK FOOTER //
// ./src/routes/private/PerfilUsuario/hoc/index.js